import React from 'react'
import { connect } from 'react-redux'
import { Icon } from "antd"
import "./pdf-tag.css"
import { injectIntl } from 'react-intl'
import classNames from 'classnames'
class PdfTag extends React.Component {


    constructor(props) {
        super(props)
        this.state = {}
    }
    onClickHandler = () => {
        const { onClick, versionNumber, pdfCarouselIndex, intl } = this.props

        if (onClick) {
            onClick(versionNumber, pdfCarouselIndex, intl)

        }
    }

    render() {
        const { pdfCarouselIndex, versionNumber, onClick } = this.props
        const pageNumber = pdfCarouselIndex === 0 ? 1 : pdfCarouselIndex

        var classes = classNames({
            'tagFile': true,
            'cursor-pointer': (onClick) ? true : false,

        });

        return (
            <React.Fragment>

                <p className={classes} onClick={this.onClickHandler}>
                    <Icon type="file" style={{ "fontSize": "15px", "color": "#FAFAFA", "marginRight": "5px" }} />
                    pag {pageNumber} v.{versionNumber}
                </p>


            </React.Fragment>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    return {}
}


export default injectIntl(connect(mapStateToProps, null)(PdfTag))
